var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCirclePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.3813C17.6294 21.3813 22.2847 16.7261 22.2847 11.0967C22.2847 5.45703 17.6294 0.812012 11.9897 0.812012C6.36035 0.812012 1.71533 5.45703 1.71533 11.0967C1.71533 16.7261 6.37061 21.3813 12 21.3813ZM12 20.0483C7.03711 20.0483 3.04834 16.0493 3.04834 11.0967C3.04834 6.13379 7.03711 2.13477 11.9897 2.13477C16.9526 2.13477 20.9619 6.13379 20.9619 11.0967C20.9619 16.0493 16.9629 20.0483 12 20.0483ZM7.33447 11.0967C7.33447 11.4658 7.61133 11.7427 8.01123 11.7427H11.3335V15.0752C11.3335 15.4648 11.6104 15.7417 11.9795 15.7417C12.3794 15.7417 12.6562 15.4648 12.6562 15.0752V11.7427H15.9888C16.3784 11.7427 16.6553 11.4658 16.6553 11.0967C16.6553 10.6968 16.3784 10.4199 15.9888 10.4199H12.6562V7.09766C12.6562 6.69775 12.3794 6.4209 11.9795 6.4209C11.6104 6.4209 11.3335 6.70801 11.3335 7.09766V10.4199H8.01123C7.61133 10.4199 7.33447 10.6968 7.33447 11.0967Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlus);
export default __webpack_public_path__ + "static/media/Circle Plus.34d1af161f106bec31b48cea0b16b0ac.svg";
export { ForwardRef as ReactComponent };